/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceLevelConfigurationResource
 */
export interface ServiceLevelConfigurationResource {
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    regularPricingPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    regularPricingPlanName?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    regularDefaultFees?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    strategyPricingPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    strategyPricingPlanName?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    strategyDefaultFees?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    expensePricingPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    expensePricingPlanName?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelConfigurationResource
     */
    expenseDefaultFees?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceLevelConfigurationResource
     */
    profileViewsLimit?: number;
}

/**
 * Check if a given object implements the ServiceLevelConfigurationResource interface.
 */
export function instanceOfServiceLevelConfigurationResource(value: object): value is ServiceLevelConfigurationResource {
    return true;
}

export function ServiceLevelConfigurationResourceFromJSON(json: any): ServiceLevelConfigurationResource {
    return ServiceLevelConfigurationResourceFromJSONTyped(json, false);
}

export function ServiceLevelConfigurationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLevelConfigurationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'regularPricingPlanId': json['regularPricingPlanId'] == null ? undefined : json['regularPricingPlanId'],
        'regularPricingPlanName': json['regularPricingPlanName'] == null ? undefined : json['regularPricingPlanName'],
        'regularDefaultFees': json['regularDefaultFees'] == null ? undefined : json['regularDefaultFees'],
        'strategyPricingPlanId': json['strategyPricingPlanId'] == null ? undefined : json['strategyPricingPlanId'],
        'strategyPricingPlanName': json['strategyPricingPlanName'] == null ? undefined : json['strategyPricingPlanName'],
        'strategyDefaultFees': json['strategyDefaultFees'] == null ? undefined : json['strategyDefaultFees'],
        'expensePricingPlanId': json['expensePricingPlanId'] == null ? undefined : json['expensePricingPlanId'],
        'expensePricingPlanName': json['expensePricingPlanName'] == null ? undefined : json['expensePricingPlanName'],
        'expenseDefaultFees': json['expenseDefaultFees'] == null ? undefined : json['expenseDefaultFees'],
        'profileViewsLimit': json['profileViewsLimit'] == null ? undefined : json['profileViewsLimit'],
    };
}

export function ServiceLevelConfigurationResourceToJSON(value?: ServiceLevelConfigurationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'countryCode': value['countryCode'],
        'regularPricingPlanId': value['regularPricingPlanId'],
        'regularPricingPlanName': value['regularPricingPlanName'],
        'regularDefaultFees': value['regularDefaultFees'],
        'strategyPricingPlanId': value['strategyPricingPlanId'],
        'strategyPricingPlanName': value['strategyPricingPlanName'],
        'strategyDefaultFees': value['strategyDefaultFees'],
        'expensePricingPlanId': value['expensePricingPlanId'],
        'expensePricingPlanName': value['expensePricingPlanName'],
        'expenseDefaultFees': value['expenseDefaultFees'],
        'profileViewsLimit': value['profileViewsLimit'],
    };
}

